import { DatasetImageSection } from "@/modules/dataset-image/dataset-image-section";
import { useInterventionSectionDatasetImage } from "@/modules/intervention/intervention-section-datasets";

const InterventionSectionImages = () => {
  const { key, loading, disabled, template, datasets } =
    useInterventionSectionDatasetImage();

  if (!template) return null;

  return (
    <div className="intervention-section-images" key={key}>
      <DatasetImageSection
        template={template}
        datasets={datasets}
        disabled={disabled}
        loading={loading}
      />
    </div>
  );
};

export default InterventionSectionImages;
